<div class="container align-items-center d-flex" style="height: 100%;">
    <div id="formContent">
      <div class="fadeIn first p-5">
        <img src="../../../assets/Images/frenda-logo.png" id="icon" alt="Logo" />
      </div>
  
      <form class="fadeIn first">
        <input type="password" id="password" class="fadeIn second" name="password" autocomplete="on" [(ngModel)]="password" placeholder="{{ 'PAGES.LOGIN.PASSWORD' | translate }}" (keyup.enter)="login()">
        <input type="submit" class="fadeIn third" value="{{ 'PAGES.LOGIN.LOGIN' | translate }}" (click)="login()">
      </form>
  
      <div id="formFooter">
          <div class="error-text">{{errorMessage}}</div>
      </div>
    </div>
</div>

